import React from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit"; 
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { LocationData } from "types/models/master/MasterApp";
interface OrderActionsProps {
  data: LocationData;
}
const OrderActions: React.FC<OrderActionsProps> = ({ data }) =>{
     const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/master/manageDeviceLocation/LocationCreate/${data.id}`);
   
  };
  return (
    <Box>
      <IconButton onClick={handleEdit}>
        <EditIcon style={{ fontSize: 24 }} />
      </IconButton>
    </Box>
  );
};

export default OrderActions;
